export const LOADING_BREADCRUMB = {
    url: '#',
    displayName: 'Loading...'
};
export const ONE_TRUST_SDK_URL = 'one_trust_sdk';
export const CALIFORNIA_PRIVACY_CHOICES_URL = 'https://www.applovin.com/privacy-ca-residents';
//# sourceMappingURL=constants.js.map